import classNames from 'classnames'
import React, { ReactNode, useEffect } from 'react'

export interface MainProps {
    children: ReactNode
    className?: string
    hasPadding?: boolean
}

export const Main = (props: MainProps): JSX.Element => {
    const setAppHeight: () => void = (): void => {
        document.documentElement.style.setProperty('--app-height', window.innerHeight + 'px')
    }

    useEffect(() => {
        setAppHeight()
        window.addEventListener('resize', setAppHeight)

        return (): void => {
            window.removeEventListener('resize', setAppHeight)
        }
    }, [])

    const className: string = classNames('main', props.hasPadding && 'main--with-padding', props.className)

    return <main className={className}>{props.children}</main>
}
